export enum ELayoutGroupType {
  FULL = 'FULL', // full width
  SPLIT = 'SPLIT', // split width ; image on the side, content on the other
  CARDS = 'CARDS', // cards
  UNIQUE = 'UNIQUE', // unique
}
